import useAuth from "../lib/providers/authProvider";

function LogoutPage() {
  const { logout } = useAuth();
  logout();
  return null;
}

export default LogoutPage;
